import styled from "styled-components";

export const HomeHeroBannerIcons = styled.div`
  position: absolute;
  z-index: 12;
  height: 470px;
  left: 0;
  right: 0;
  max-width: 1550px;
  margin: -235px auto 0;
  display: flex;
  justify-content: center;

  @media (max-width: 1300px) {
    margin: -160px auto 0;
  }

  @media (max-width: 1200px) {
    height: 370px;
    margin: -40px auto 0;
  }

  @media (max-width: 767.98px) {
    margin: -150px auto 0;
    margin-top: calc(-100vh + 500px);
    position: relative;
  }

  &.scroll-down {
    position: fixed;
    top: 60px;
    max-width: 100%;
  }

  ul {
    display: flex;
    justify-content: space-between;
    color: white;
    max-width: 1550px;
    background: black;
    margin: 0 40px;
    align-items: center;
    height: 100%;
    padding: 0 150px;
    width: 100%;
    margin: 0 40px;

    @media (max-width: 1200px) {
      padding: 30px 60px 0;
    }

    @media (max-width: 767.98px) {
      padding: 10px 20px 0;
      margin: 0;
    }

    li {
      position: relative;
      z-index: 9;
      flex-grow: 1;
      max-width: 270px;
      padding: 0 20px;

      @media (max-width: 767.98px) {
        flex: 1 0 100% !important;
      }
      &.long {
        img.icon-offer {
          height: 140px !important;
        }
      }
      &.sell {
        img.icon-offer {
          height: 140px !important;
        }
      }
      span.sell-item {
        display: block;
        position: relative;
        text-align: left;
        text-decoration: none;
        transition: all 0.3s ease;

        img {
          width: auto;
          margin: 0 auto;
          cursor: pointer;
          transition: all 0.3s ease;
          &.icon-offer {
            padding-bottom: 0px;
          }
          &.arrow-icon {
            bottom: 0;
            height: 14px;
            margin-top: 35px;
            opacity: 0;
            position: absolute;
            transition: all 0.3s ease;
            left: 0;
            margin-left: auto;
            margin-right: auto;
            right: 0;
          }
          &:hover {
            cursor: pointer;
          }
        }
        h5 {
          color: #ff5000;
          font-size: 20px;
          font-weight: 600;
          margin: 40px 0 20px;
          transition: all 0.3s ease;
        }
        p {
          font-family: "Roboto Mono";
          color: #8f9092;
          font-size: 14px;
          text-transform: none;
          font-weight: 300;
          line-height: 26px;
          max-width: 300px;
        }
      }
    }

    li:last-child {
      a {
        /* border-right: 1px solid transparent; */
      }
    }
  }

  @media (max-width: 767.98px) {
    height: auto;
    width: calc(100% - 60px);

    ul {
      flex-flow: row;
      flex-wrap: wrap;
      flex-flow: column;
      padding: 120px 0 100px;

      li {
        padding-bottom: 100px;
        max-width: 70%;

        span.sell-item {
          p {
            line-height: 22px;
          }
        }
        &:last-child {
          padding-bottom: 0;
        }
      }
    }
  }
`;
